/* eslint-disable */
import {extendDecorator, viewModelDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import Vue from 'vue';
import { getConfirmationTypeName, getConfirmationTypeAdditionals, ConfirmationTypeIcon, ConfirmationType } from '@entities/confirmationType'
import './style.scss';
import template from './template.html';
import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';

@viewModelDecorator({
    warranted: false,
})
@extendDecorator({
    template,
    bindings: {
        label: 'classes:{checked:warranted}',
        input: 'checked:warranted',
    },
})
export default class WarrantedView extends Backbone.Epoxy.View {
    initialize() {
        this.initModelEvents();
        this.render();
        this.initComponents();
    }

    initModelEvents() {
        this.viewModel.mapState({
            warranted: 'model',
        }, this.model);

        this.viewModel.on('change:warranted', (model, value) => {
            this.model.set({
                model: value,
            }, {initiator: 'view'});
        });
    }

    render() {
        this.$el.html(template({
            name: getConfirmationTypeName(ConfirmationType.Quick),
            additionals: getConfirmationTypeAdditionals(ConfirmationType.Quick), 
        }));
        if(this.el?.querySelector('.js-warranted-confirmation-icon')) {
            new Vue({
                render: (h) => h(ConfirmationTypeIcon, {
                    props: {
                        type: ConfirmationType.Quick,
                        additionals: false,
                        size: 'm',
                    },
                }),
            }).$mount(this.el.querySelector('.js-warranted-confirmation-icon'));
        }
    }

    initComponents() {
        this.warrantyTooltip = new TooltipPopoverHtml({
            el: $('.js-warranted-icon', this.$el),
        });
    }
}